export const getBreadcrumbs = items => items.map(item => ({
  ...(item.label && {label: item.label}),
  ...(item.schemaLabel && {schemaLabel: item.schemaLabel}),
  ...(item.href && {href: item.href}),
  ...(item.schemaHref && {schemaHref: item.schemaHref})
}));
